import type { PartialDeep } from "type-fest";

import type { Common } from "./common.js";

export default {
  role: {
    officer: "MET Officer",
    commandunit: "Basic Command Unit",
  },
  incidentWorkItem: {
    commandUnit: "Basic Command Unit",
    geographicUnit: "Sector ID",
    type: {
      voluntary: "Alternative Pathway",
      other: "Arrest for Criminal Offence",
    },
  },
  userProfile: {
    shoulderNumber: "Warrant Number",
  },
  common: {
    dispatchNumber: "CAD Number",
    shoulderNumber: "Warrant Number",
  },
  createIncident: {
    incidentLocation: "Location of incident",
    incidentLocationBanner:
      "Section 136 powers cannot be used in a private dwelling. Please use the checkbox above as needed, to indicate exact location of detention.",
    personForename: "Person's forename(s)",
    outsideAboveAddress: "Outside above address",
    commandUnit: "In which BCU did the detention happen?",
    commandUnitRequired:
      "Please select the BCU in which this detention occurred",
  },
  detentionDetails: {
    custodyNumber: "Custody Number",
    custodyNumber_136: "Custody Number",
    custodyNumber_mca: "Custody Number",
    dateOfDetention: "Date of detention",
    timeOfDetention: "Time of detention",
    createdOnBehalfOfAnotherOfficerWithShoulderNumber:
      "Please confirm the Warrant Number of the detaining officer",
    createdOnBehalfOfAnotherOfficerRequired:
      "Please add the warrant number of the officer who detained the person",
    locationType: {
      policeStations: "Police stations/Custody ",
      nonResidentialRestricted:
        "Communal areas in multiple-occupant accommodation",
    },
  },

  admin: {
    incidents: {
      incidentNumber: "CAD Number",
      voluntary: "Alternative Pathway",
    },
  },
  informationForHealthcare: {
    wasHealthcareProvided:
      "Was physical health care provided prior to arrival at the Place of Safety (ED or 136 Suite)?",
    wasHealthcareProvided_136:
      "Was physical health care provided prior to arrival at the Place of Safety (ED or 136 Suite)?",
    wasHealthcareProvided_mca:
      "Was physical health care provided prior to arrival at the Emergency Department?",
    wasHealthcareProvidedRequired:
      "Please confirm if physical healthcare was provided before arriving at ED/136 suite e.g. from Ambulance",
    wasHealthcareProvidedRequired_136:
      "Please confirm if physical healthcare was provided before arriving at ED/136 suite e.g. from Ambulance",
    wasHealthcareProvidedRequired_mca:
      "Please confirm if physical healthcare was provided before arriving at ED e.g. from Ambulance",
    wasForceUsed: "Was force used?",
    didSeizeProperty: "Did you seize any items (e.g. weapons or drugs)?",
    didSeizePropertyRequired: "Please confirm if you seized any items",
    detailsPropertySeized:
      "Please provide detail of the items seized (e.g. weapons or drugs)",
    describeRiskFactorsOther: "Please specify",
    underInfluenceOfSubstance:
      "Is the person suffering from the effects of drink or drugs?",
    underInfluenceOfSubstanceRequired:
      "Please confirm if the person was under the influence of drugs or alcohol",
    medicalAttentionProvided:
      "Please describe the medical attention provided to the best of your abilities",
    substanceInfluenceBanner:
      "If the individual has consumed alcohol and/or drugs to the point of being unable to either walk unaided or stand unaided or is unaware of their own actions or unable to fully understand what is said to them, this may be treated as a medical emergency and the person should be taken to an ED. ",
    hasAdditionalRiskFactors:
      "Are there any additional risk factors that should be shared with health/AMHP services?  ",
    hasAdditionalRiskFactorsRequired:
      "Please confirm if any risk factors are known that are relevant for health/AMHP.",
    clothingRemovalWarning:
      "Section 136C (MHA) does not authorise removal of clothing, other than an outer coat, jacket or gloves.",
    describeRiskFactors: {
      title: "Please select possible risk factors from extensive list below",
      options: {
        previouslySectioned:
          "Previously detained under 136 or previously sectioned",
      },
    },
  },
  personDetails: {
    ethnicity: {
      options: {
        IC1: "1 White - North European",
        IC2: "2 White - South European",
        IC3: "3 Black",
        IC4: "4 Asian",
        IC5: "5 Chinese, Japanese, or Other South East Asian",
        IC6: "6 Arabic or North African",
        IC7: "Unknown",
      },
    },
    selfDeclaredEthnicity: {
      options: {
        whiteOther: "Any other White background",
        mixedOther: "Any other Mixed / Multiple ethnic background",
        asianOther: "Any other Asian background",
        blackOther:
          "Black / African / Caribbean / Black British - Any other Black / African / Caribbean background",
      },
    },
  },
  triageIncident: {
    voluntaryServicesRecommended:
      "What type of alternative pathway did they recommend?",
    voluntaryServicesRecommendedRequired:
      "Please confirm what alternative pathway was recommended",
    reasonNotConsulted: {
      title: "Why was it not practicable to consult with a HCP?",
      options: {
        noAnswer: "Not available/no answer",
      },
    },
    howDidYouContactNhs: {
      title: "Who did you consult?",
      required: "Please confirm which healthcare professional you consulted",
      options: {
        panLondonMentalHealthAdviceLine:
          "Mental Health Clinical Advice Line (0300 200 0169)",
        custodyHealthcarePractitioner:
          "MET Custody Healthcare practitioner (Dr/RN/Para)",
        localMentalHealthAdviceLine: "Local mental health advice line",
        localHbpos: "Local HBPOS",
        controlRoom: "Control Room - IMHT",
        localStreetTriageTeam: "Local street triage team",
      },
    },
    voluntaryAction: {
      other: {
        required:
          "Please provide written description of the alternative pathway recommended",
      },
    },
    isHealthcareProfessionalConsulted:
      "Did you consult with any healthcare professional to assist with your decision making & actions taken?",
    givenHealthCareProfessionalAdvice:
      "What advice did the healthcare professional give?",
    otherActionDetails: "Please provide a brief description of advice provided",
    whatWillYouDo: {
      136: "Detain under Section 136",
      56: "Consider Mental Capacity Act",
      voluntary: "Alternative Pathway",
      other: "Arrest For Criminal Offence",
    },
    unsupportedAction:
      "This outcome is not yet available on this platform. Please continue to follow existing procedures for this incident, or contact your supervisor for more information.",
    s136MentalHealthInvestigationBanner:
      "Please complete a CONNECT 'Mental Health Investigation - Detention under S136 Mental Health Act' report. View the 'Policy Help' section in the navigation menu for operational guidance on Section 136",
    useOfMCA2005InvestigationBanner:
      "The Mental Capacity Act should <bold>not</bold> be used to circumvent the Mental Health Act and should only be used in situations where the individual lacks capacity and the primary need is for urgent medical intervention for a physical health condition.\nPlease complete a CONNECT 'Mental Health Investigation - Use of Mental Capacity Act 2005' report.\nView the 'Policy Help' section in the navigation menu for operational guidance on Mental Capacity Act.",
  },

  recordPlaceOfSafety: {
    choosePlaceOfSafetyType: {
      options: {
        hbPos136: "Health Based Place of Safety (HBPOS/136 Suite)",
        custody: "Police Custody Suite (exceptional circumstances)",
      },
    },
  },

  arrivePlaceOfSafety: {
    advisePhysicallyEnter:
      "Arrival is when you enter through the doors of the Place of Safety",
    advisePhysicallyEnter_136:
      "Arrival is when you enter through the doors of the Place of Safety",
    advisePhysicallyEnter_mca:
      "Arrival is when you enter through the doors of the Emergency Department",

    howLongWasEntryDelayed: {
      title: "How long were you delayed?",
      options: {
        "0-15": "0 - 15 mins",
        "15-30": "15 - 30 mins",
        "30-60": "30 mins - 1 hour",
        "60-120": "1 - 2 hours",
        "120+": "Over 2 hours",
      },
    },
  },

  leavePlaceOfSafety: {
    didYouLeave: "Have you moved the patient to another place of safety?",
    didYouLeave_136: "Have you moved the patient to another place of safety?",
    didYouLeave_mca:
      "Have you moved the patient to another emergency department?",
    didYouLeaveRequired:
      "Please indicate if you have moved the patient to another Place of Safety",
    didYouLeaveRequired_136:
      "Please indicate if you have moved the patient to another Place of Safety",
    didYouLeaveRequired_mca:
      "Please indicate if you have moved the patient to another Emergency Department",

    leaveReason: {
      title: "Why was the patient moved?",
      required:
        "Please confirm why the patient was moved from this Place of Safety",
      required_136:
        "Please confirm why the patient was moved from this Place of Safety",
      required_mca:
        "Please confirm why the patient was moved from this Emergency Department",
      options: {
        moreAppropriatePosAvailable: "A more appropriate POS became available",
        moreAppropriatePosAvailable_136:
          "A more appropriate POS became available",
        moreAppropriatePosAvailable_mca:
          "A more appropriate ED became available",
        unreasonableDelay: "Unreasonable delay in accessing POS",
        unreasonableDelay_136: "Unreasonable delay in accessing POS",
        unreasonableDelay_mca: "Unreasonable delay in accessing ED",
        visitAccidentAndEmergencyOnMedicalGrounds:
          "Medical attention needed (attending A&E)",
        physicalHealthCheckComplete: "Physical health check complete ",
        other: "Other (please specify)",
      },
    },
    leaveAuthorisedBy: {
      required:
        "Please indicate who authorised the transfer between Places of Safety",
      required_136:
        "Please indicate who authorised the transfer between Places of Safety",
      required_mca:
        "Please indicate who authorised the transfer between Emergency Departments",
    },
  },

  endIncidentCommon: {
    incidentOutcome: {
      options: {
        unknownHandover: "Unknown - Handover of care before assessment done",
      },
    },
  },
  preEndIncident: {
    whyNhsNotEngage: {
      title: "Why did you not share the form with the NHS?",
      required:
        "Please select the reason you did not share the form with the NHS",
      options: {
        internetConnection: "Internet connectivity issues",
        startedFormInError: "Started form in error",
        nhsUsingOtherProcess: "NHS insisted on using other form/process",
        emailNotReceived: "Email not received by NHS",
        handoverCompletedVerbally:
          "No forms used locally, handover completed verbally",
        localForm: "Insisted on using local form/process ",
        other: "Other (please specify)",
      },
      additionalInformationNotEngage: "Please specify",
      additionalInformationNotEngageRequired:
        "Please specify why you didn't share with the NHS",
    },

    reasonForPolicePresenceRequest: {
      title: "What reason were you given for this request?",
    },
    whatWillYouDo: {
      title: "What action have you taken in response to NHS request?",
    },
    remainedAtPos:
      "Have you remained, or will you remain, at the Place of Safety?",
    remainedAtPos_136:
      "Have you remained, or will you remain, at the Place of Safety?",
    remainedAtPos_mca:
      "Have you remained, or will you remain, at the Emergency Department?",
  },

  finishForm: {
    whatWasTheOutcome136: {
      title: "What was the outcome of the Section 136 incident?",
      options: {
        unknownHandover:
          "Unknown - Handover completed before MHA assessment done",
      },
    },
  },
  placeOfSafetyPicker: {
    selectManualEnter:
      'Please search and select a Place of Safety or choose "Manually Input place of Safety"',
    selectManualEnter_136:
      'Please search and select a Place of Safety or choose "Manually Input place of Safety"',
    selectManualEnter_mca:
      'Please search and select an Emergency Department or choose "Manually Input Emergency Department"',
    name: "Place of Safety Name",
    name_136: "Place of Safety Name",
    name_mca: "Emergency Department Name",
    address: "Address of Place of Safety",
    address_136: "Address of Place of Safety",
    address_mca: "Address of Emergency Department",
  },
} satisfies PartialDeep<Common>;
